/**
 * @deprecated
 */
export enum FieldTypes {
  Email = 'email',
  Password = 'password',
  Text = 'text',
  Number = 'number',
}
/**
 * @deprecated
 */
export enum EmailFieldValidationMessages {
  EmailFieldCantBeEmpty = 'emailFieldCantBeEmpty',
  PleaseEnterAValidEmailFormat = 'pleaseEnterAValidEmailFormat',
}

